
define('modules/application/wizard/steps/zoneStep/complexZoneStep/intrusionDetectionZoneStep',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../complexZoneStep",
  "./intrusionDetectionZoneStep/zoneModel",
  "./intrusionDetectionZoneStep/zoneDetailView",
  "./intrusionDetectionZoneStep/zonesMenuView",
  "../../../classes/volumetricProtection",
  "../../../classes/perimetralProtection",
  "../../../classes/radioSensors"
],

function(
  app,
  Backbone,
  jQueryUi,
  complexZoneStep,
  ZoneModel,
  ZoneDetailView,
  ZonesMenuView,
  volumetricProtection,
  perimetralProtection,
  radioSensors) {

  var Views        = _.extend({}, complexZoneStep.Views);

  Views.Content    = Views.Content.extend({
    addConstructors : function() {
      complexZoneStep.Views.Content.prototype.addConstructors.apply(this);
      this.ZoneDetailView = ZoneDetailView;
      this.ZonesMenuView = ZonesMenuView;
    }
  });

  var intrusionDetectionZoneStep = _.extend({}, complexZoneStep, {
    objClass      : "intrusionDetectionZoneStep",
    Model         : complexZoneStep.Model.extend({
      addConstructors                     : function() {
        complexZoneStep.Model.prototype.addConstructors.apply(this);
        this.ZoneModel            = ZoneModel;
        this.ZoneDetailView       = ZoneDetailView;
        this.ZonesMenuView        = ZonesMenuView;
        this.volumetricProtection = volumetricProtection;
        this.perimetralProtection = perimetralProtection;
        this.radioSensors         = radioSensors;
      },

      initialize                          : function() {
        complexZoneStep.Model.prototype.initialize.apply(this);
        this.get("stepEventAggregator").unbind("zoneStatusCheck:requested",  this.checkZonesStatus);
        this.get("stepEventAggregator").bind("zoneStatusCheck:requested",    this.checkZonesStatus, this);

        window.BticinoS4B.eventAggregator.bind("contactConnectionRequired",                this.contactConnectionRequiredEventHandler, this);
        window.BticinoS4B.eventAggregator.bind("contactsDisconnectionRequired",            this.contactsDisconnectionRequiredEventHandler, this);
        window.BticinoS4B.eventAggregator.bind("contactDisconnectionRequired",             this.contactDisconnectionRequiredEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("volumetricProtection:addedFromKit",      this.volumetricProtectionAddedFromKitEventHandler);
        window.BticinoS4B.eventAggregator.bind("volumetricProtection:addedFromKit",        this.volumetricProtectionAddedFromKitEventHandler, this);

        window.BticinoS4B.eventAggregator.bind("volumetricProtection:removeKitPackage",    this.removeKitPackage, this);

        window.BticinoS4B.eventAggregator.unbind("removeKitItems",                         this.removeKitItems);
        window.BticinoS4B.eventAggregator.bind("removeKitItems",                           this.removeKitItems, this);
      },

      volumetricProtectionAddedFromKitEventHandler: function(addedVolumetricProtection) {
        var zoneToConnect     =  addedVolumetricProtection.addToZone,
            collection        =  this.collection,
            collectionLength  =  collection.length;

        for (var i = collectionLength; i<zoneToConnect; i++) {
          this.addZone(null);
        }

        for (i = collection.length - 1; i >= 0; i--) {
          if (collection.models[i].get("number")===Number(zoneToConnect))
          {
            collection.models[i].get("volumetricProtectionModel").productAddedFromKitEventHandler(addedVolumetricProtection);
            break;
          }
        }
      },

      removeKitItems                              : function() {
        var collection       = this.collection,
            collectionLength = collection.length,
            i                = 0;
        for (i=0; i<collectionLength; i++)
          collection.models[i].get("volumetricProtectionModel").removeKitItems();
      },

      removeKitPackage                            : function(packageToRemove) {
        var zoneToExaminate = _.filter(this.collection.models, function(iterableZone){return iterableZone.get("number")===Number(packageToRemove.addToZone);})[0];

        zoneToExaminate.get("volumetricProtectionModel").removeKitItem(packageToRemove);
      },

      contactConnectionRequiredEventHandler       : function(contactToConnect) {
        var collection        =  this.collection,
            collectionLength  =  collection.length;

        for (var i = collectionLength; i<contactToConnect.zoneToConnect; i++) {
          this.addZone(null);
        }

        var zoneToConnect = _.filter(this.collection.models, function(iterableZone){
          return iterableZone.get("number")===contactToConnect.zoneToConnect;
        })[0];

        zoneToConnect.get("perimetralProtectionModel").addMainControlUnitContact(contactToConnect.contactToConnect);
      },

      contactDisconnectionRequiredEventHandler       : function(contactToDisconnect) {
        var collection        =  this.collection,
            collectionLength  =  collection.length;

        var zoneToDisconnect  = _.filter(this.collection.models, function(iterableZone){
          return iterableZone.get("number")===contactToDisconnect.contactToDisconnect.connectedTo;
        })[0];

        zoneToDisconnect.get("perimetralProtectionModel").removeMainControlUnitContact(contactToDisconnect.contactToDisconnect);
      },

      contactsDisconnectionRequiredEventHandler       : function() {
        var collection        =  this.collection;

        for (var i = collection.models.length - 1; i >= 0; i--) {
          collection.models[i].get("perimetralProtectionModel").removeMainControlUnitContacts();
        }
      },

      checkZonesStatus                     : function() {
        if (this.collection.checkZonesStatus() && BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") && BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")!==0)
          this.get("stepEventAggregator").trigger('collection:validated');
        else
          this.get("stepEventAggregator").trigger('collection:unvalidated');
      },

      getZoneNumber                       : function(zoneName) {
        var zoneNumber = -101;

        if (zoneName==="IDS_WAI1001_9006")
          zoneNumber = 0;//-1;
        else if (zoneName==="IDS_WAI1001_9007")
          zoneNumber = 9;

        return zoneNumber;
      },

      duplicateSelectedZone               : function() {
        var selectedModel = this.collection.filter(function(currentModel){
          return currentModel.get("selected");
        });

        this.duplicateZone(selectedModel);
      },

      duplicateZone                       : function(selectedModel) {
        if (selectedModel[0].isDuplicable())
        {
          var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;

          if (this.collection.length<maxZoneNumber)
          {
            //Creating base model
            var modelToAdd = new this.ZoneModel(
              _.extend(
                selectedModel[0].toJSON(),
                {number : this.collection.length+1}
              )
            );

            var k=2;
            var nameFound;
            while (!nameFound) {
              for (var i=0; i<this.collection.models.length; i++) {
                if(modelToAdd.get("name").indexOf('{defaultName}')===0)
                {
                  modelToAdd.set("name", '{defaultName} '+modelToAdd.get("number"));
                  nameFound=true;
                  break;
                }
                else
                {
                  if (this.collection.models[i].get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))==(modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))+"("+k+")"))
                  {
                    break;
                  }
                  else
                  {
                    if (i==this.collection.models.length-1)
                    {
                      nameFound=true;
                      modelToAdd.set("name", modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))+"("+k+")");
                    }
                  }
                }
              }
              if (!nameFound)
                k++;
            }

            //////////////////////////////////
            //Creating new this.volumetricProtectionModel
            //////////////////////////////////

            var volumetricProtectionModelToAdd    = new this.volumetricProtection.Model(
              _.extend({stepEventAggregator :  this.get("stepEventAggregator"), zoneEventAggregator : this.get("zoneEventAggregator")}, selectedModel[0].get("volumetricProtectionModel").attributes)
            );
            //Removeing kit elements before pass the collection
            for (var j = volumetricProtectionModelToAdd.attributes.collection.models.length - 1; j >= 0; j--) {
              volumetricProtectionModelToAdd.attributes.collection.models[j].set("partOfKit", false);
              volumetricProtectionModelToAdd.attributes.collection.models[j].set("addToZone", undefined);
              volumetricProtectionModelToAdd.attributes.collection.models[j].set("kitsEventAggregator", undefined);
            }
            modelToAdd.set("volumetricProtectionModel", volumetricProtectionModelToAdd);

            //////////////////////////////////
            //Creating new this.perimetralProtectionModel
            //////////////////////////////////
            var perimetralProtectionModelToAdd    = new this.perimetralProtection.Model(
              _.extend({stepEventAggregator :  this.get("stepEventAggregator"), zoneEventAggregator : this.get("zoneEventAggregator")}, selectedModel[0].get("perimetralProtectionModel").attributes)
            );
            modelToAdd.set("perimetralProtectionModel", perimetralProtectionModelToAdd);

            //////////////////////////////////
            //Creating new this.radioSensorsModel
            //////////////////////////////////
            var radioSensorsModelToAdd            = new this.radioSensors.Model(
              $.extend({stepEventAggregator :  this.get("stepEventAggregator"), zoneEventAggregator : this.get("zoneEventAggregator")}, selectedModel[0].get("radioSensorsModel").attributes)
            );
            modelToAdd.set("radioSensorsModel", radioSensorsModelToAdd);

            //Adding new this.model to the collection
            this.addZone(modelToAdd);
            this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          }
          else {
            alert($.i18n._("IDS_W1_9090"));
          }
        }
        else
          alert("This zone cannot be duplicated because it contains elements from other sections. Please add a new one");
      },

      mainControlUnitSelectedEventHandler : function(model, event, maxZoneNumber, _force) {
        var toReturn        = true,
            mustRemoveZones = false,
            force           = _force;

        if (_force)
          force = _force;

        //If I am passing from a 99zones central to 4zones one
        if (this.collection.length>maxZoneNumber) {

          //If there are more than maxZoneNumber zones
          if (confirm($.i18n._("IDS_W1_9092", [(maxZoneNumber+1), this.collection.length])))
            mustRemoveZones = true;
          else
            toReturn = false;
        }

        //Inserters compatibility
        var insertersZone = _.filter(this.additionalZones, function(zone) {
          if (zone.attributes)
            return (zone.get("name") === "IDS_WAI1001_9006");
          else
            return false;
        });

        if (insertersZone.length===1)
          insertersZone = insertersZone[0];

        if (insertersZone.get("insertersModel")) {
          if (insertersZone.get("insertersModel").isThereAnIncompatibleInserterAtLeast(maxZoneNumber))
            //If there are more than maxZoneNumber zones
            if (confirm($.i18n._("IDS_WTR1002_9009"))) {
              insertersZone.get("insertersModel").removeIncompatibleInserters(maxZoneNumber);
              toReturn = true;
            }
            else
              toReturn = false;
        }

        //Remove zones in excess
        if (mustRemoveZones)
          for(var i=this.collection.length-1; i>=maxZoneNumber; i--)
            this.removeZone(this.collection.models[i]);

        if (toReturn)
          window.BticinoS4B.eventAggregator.trigger("mainControlUnit:changeApproved", event);
        else
          window.BticinoS4B.eventAggregator.trigger("mainControlUnit:changeNotApproved", event);
      },

      deliverModel                        : function() {
        var additionalZones = this.additionalZones,
            regularZones    = this.collection.models,
            dataProvider    = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i=0, j=0, l=0, m=0;

        BticinoS4B.solution.intrusionDetection.zones = this;
        BticinoS4B.Instances.Models.ApplicationModel.set("zones", BticinoS4B.solution.intrusionDetection.zones);
        BticinoS4B.solution.intrusionDetection.additionalZones = additionalZones;
        BticinoS4B.Instances.Models.ApplicationModel.set("additionalZones", BticinoS4B.solution.intrusionDetection.additionalZones);

        zonesItems          = BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") : [];

        //Additional zones
        for (i=0; i<additionalZones.length; i++)
        {
          if (additionalZones[i].attributes)
          {
            zoneToPush = {
              name   : additionalZones[i].get("name"),
              number : additionalZones[i].get("number"),
              items: []
            };

            //Inserters zone
            if (additionalZones[i].get("name")==="IDS_WAI1001_9006")
            {

              //Inserters section
              if(additionalZones[i].get("insertersModel"))
              {
                modelToAnalyse = additionalZones[i].get("insertersModel");

                for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
                {
                  singleModel = modelToAnalyse.get("collection").models[j];
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : singleModel.get("partOfKit"),
                    productCode        : singleModel.get("productCode"),
                    productLabel       : singleModel.get("productLabel"),
                    packageClassLabel  : singleModel.get("packageClassLabel"),
                    packageClassId     : singleModel.get("packageClassId"),
                    quantity           : 1,
                    price              : singleModel.get("price"),
                    progNumber         : singleModel.get("progNumber"),
                    isInserter: true
                  });

                  for (l=0; l<singleModel.get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : singleModel.get("secondaryProducts")[l].partOfKit,
                      productCode        : singleModel.get("secondaryProducts")[l].productCode,
                      productLabel       : singleModel.get("secondaryProducts")[l].productLabel,
                      packageClassLabel  : singleModel.get("secondaryProducts")[l].packageClassLabel,
                      packageClassId     : singleModel.get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : singleModel.get("secondaryProducts")[l].price
                    });
                  }
                }
              }

              zonesItems.push(zoneToPush);
            }
            //Auxiliaries section
            else if (additionalZones[i].get("name")==="IDS_WAI1001_9007")
            {

              //Technical bus alarms section
              if(additionalZones[i].get("technicalBusAlarmModel"))
              {
                modelToAnalyse = additionalZones[i].get("technicalBusAlarmModel");

                if (modelToAnalyse.get("collection").models)
                  for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
                  {
                    singleModel = modelToAnalyse.get("collection").models[j];

                    if (singleModel.get("_interface"))
                      dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                        partOfKit          : singleModel.get("_interface").partOfKit,
                        productCode        : singleModel.get("_interface").productCode,
                        productLabel       : singleModel.get("_interface").productLabel,
                        packageClassLabel  : singleModel.get("_interface").packageClassLabel,
                        packageClassId     : singleModel.get("_interface").packageClassId,
                        quantity           : 1,
                        price              : singleModel.get("_interface").price,
                        progNumber         : singleModel.get("_interface").progNumber
                      });

                    if (singleModel.get("_interface").secondaryProducts)
                      for (l=0; l<singleModel.get("_interface").secondaryProducts.length; l++) {
                        dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                          partOfKit          : singleModel.get("_interface").secondaryProducts[l].partOfKit,
                          productCode        : singleModel.get("_interface").secondaryProducts[l].productCode,
                          productLabel       : singleModel.get("_interface").secondaryProducts[l].productLabel,
                          packageClassLabel  : singleModel.get("_interface").secondaryProducts[l].packageClassLabel,
                          packageClassId     : singleModel.get("_interface").secondaryProducts[l].packageClassId,
                          quantity           : 1,
                          price              : singleModel.get("_interface").secondaryProducts[l].price
                        });
                      }

                    if (singleModel.get("type"))
                      dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                        partOfKit          : singleModel.get("type").partOfKit,
                        productCode        : singleModel.get("type").productCode,
                        productLabel       : singleModel.get("type").productLabel,
                        packageClassLabel  : singleModel.get("type").packageClassLabel,
                        packageClassId     : singleModel.get("type").packageClassId,
                        quantity           : 1,
                        price              : singleModel.get("type").price,
                        isAllarmType       : true
                      });

                    if (singleModel.get("type").secondaryProducts)
                      for (l=0; l<singleModel.get("type").secondaryProducts.length; l++) {
                        dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                          partOfKit          : singleModel.get("type").secondaryProducts[l].partOfKit,
                          productCode        : singleModel.get("type").secondaryProducts[l].productCode,
                          productLabel       : singleModel.get("type").secondaryProducts[l].productLabel,
                          packageClassLabel  : singleModel.get("type").secondaryProducts[l].packageClassLabel,
                          packageClassId     : singleModel.get("type").secondaryProducts[l].packageClassId,
                          quantity           : 1,
                          price              : singleModel.get("type").secondaryProducts[l].price,
                          isAllarmType       : true
                        });
                      }
                  }
              }

              //Technical radio alarms section
              if(additionalZones[i].get("technicalRadioAlarmModel")) {
                modelToAnalyse = additionalZones[i].get("technicalRadioAlarmModel");

                if(modelToAnalyse.get("collection").models)
                  for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
                  {
                    singleModel = modelToAnalyse.get("collection").models[j];
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : singleModel.get("partOfKit"),
                      productCode        : singleModel.get("productCode"),
                      productLabel       : singleModel.get("productLabel"),
                      packageClassLabel  : singleModel.get("packageClassLabel"),
                      packageClassId     : singleModel.get("packageClassId"),
                      quantity           : 1,
                      price              : singleModel.get("price")
                    });

                    for (l=0; l<singleModel.get("secondaryProducts").length; l++) {
                      dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                        partOfKit          : singleModel.get("secondaryProducts")[l].partOfKit,
                        productCode        : singleModel.get("secondaryProducts")[l].productCode,
                        productLabel       : singleModel.get("secondaryProducts")[l].productLabel,
                        packageClassLabel  : singleModel.get("secondaryProducts")[l].packageClassLabel,
                        packageClassId     : singleModel.get("secondaryProducts")[l].packageClassId,
                        quantity           : 1,
                        price              : singleModel.get("secondaryProducts")[l].price
                      });
                    }
                  }
              }
              zonesItems.push(zoneToPush);
            }
          }
        }

        //Regular zones
        for (i=0; i<regularZones.length; i++) {
          zoneToPush = {
            name   : regularZones[i].get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003")),
            number : regularZones[i].get("number"),
            items: []
          };

          if (regularZones[i].get("volumetricProtectionModel"))
          {
            modelToAnalyse = regularZones[i].get("volumetricProtectionModel");
            for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
            {
              singleModel = modelToAnalyse.get("collection").models[j];
              //if (!singleModel.get("partOfKit"))
              //{
                dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                  generatedId        : singleModel.get("generatedId"),
                  productCode        : singleModel.get("productCode"),
                  productLabel       : singleModel.get("productLabel"),
                  packageClassLabel  : singleModel.get("packageClassLabel"),
                  packageClassId     : singleModel.get("packageClassId"),
                  partOfKit          : singleModel.get("partOfKit"),
                  kitValue           : singleModel.get("kitValue"),
                  quantity           : 1,
                  price              : singleModel.get("price"),
                  zoneNumber         : singleModel.get("zoneNumber"),
                  progNumber         : singleModel.get("progNumber")
                });

                for (l=0; l<singleModel.get("secondaryProducts").length; j++) {
                  dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                    productCode        : singleModel.get("secondaryProducts")[l].get("productCode"),
                    productLabel       : singleModel.get("secondaryProducts")[l].get("productLabel"),
                    packageClassLabel  : singleModel.get("secondaryProducts")[l].get("packageClassLabel"),
                    packageClassId     : singleModel.get("secondaryProducts")[l].get("packageClassId"),
                    partOfKit          : singleModel.get("partOfKit"),
                    kitValue           : singleModel.get("kitValue"),
                    quantity           : 1,
                    price              : singleModel.get("secondaryProducts")[l].get("price"),
                    progNumber         : singleModel.get("secondaryProducts")[l].get("progNumber")
                  });
                }
              //}
            }
          }

          if (regularZones[i].get("perimetralProtectionModel")) {
            modelToAnalyse = regularZones[i].get("perimetralProtectionModel");
            for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
            {
              singleModel = modelToAnalyse.get("collection").models[j];
              //dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
              //  productCode        : singleModel.get("_interface").productCode,
              //  productLabel       : singleModel.get("_interface").productLabel,
              //  packageClassLabel  : singleModel.get("_interface").packageClassLabel,
              //  quantity           : 1,
              //  price              : singleModel.get("_interface").price
              //});
//
              //if (singleModel.get("secondaryProducts"))
              //  for (l=0; l<singleModel.get("_interface").secondaryProducts.length; j++)
              //  {
              //    dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
              //      productCode        : singleModel.get("_interface").secondaryProducts[l].productCode,
              //      productLabel       : singleModel.get("_interface").secondaryProducts[l].productLabel,
              //      packageClassLabel  : singleModel.get("_interface").secondaryProducts[l].packageClassLabel,
              //      quantity           : 1,
              //      price              : singleModel.get("_interface").secondaryProducts[l].price
              //    });
              //  }
//
              for (l=0; l<singleModel.get("protections").length; l++)
              {
                if(singleModel.get("protections")[l].get("type").productCode!=="EXT_1218")
                  if (singleModel.get("protections")[l].get("state")==="0")
                    dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                      productCode        : singleModel.get("protections")[l].get("type").productCode,
                      productLabel       : singleModel.get("protections")[l].get("type").productLabel,
                      packageClassLabel  : singleModel.get("protections")[l].get("type").packageClassLabel,
                      packageClassId     : singleModel.get("protections")[l].get("type").packageClassId,
                      quantity           : singleModel.get("protections")[l].get("value"),
                      price              : singleModel.get("protections")[l].get("type").price,
                      state              : singleModel.get("protections")[l].get("state"),
                      progNumber         : singleModel.get("protections")[l].get("number")
                    });

                if(singleModel.get("protections")[l].get("type").secondaryProducts)
                {
                  for (m=0; m<singleModel.get("protections")[l].get("type").secondaryProducts; m++)
                  {
                    dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                      productCode        : singleModel.get("protections")[l].get("type").secondaryProducts[m].productCode,
                      productLabel       : singleModel.get("protections")[l].get("type").secondaryProducts[m].productLabel,
                      packageClassLabel  : singleModel.get("protections")[l].get("type").secondaryProducts[m].packageClassLabel,
                      packageClassId     : singleModel.get("protections")[l].get("type").secondaryProducts[m].packageClassId,
                      quantity           : singleModel.get("protections")[l].get("value"),
                      price              : singleModel.get("protections")[l].get("type").secondaryProducts[m].price,
                      progNumber         : singleModel.get("protections")[l].get("type").secondaryProducts[m].number
                    });
                  }
                }
              }
            }
          }

          if (regularZones[i].get("radioSensorsModel"))
          {
            modelToAnalyse = regularZones[i].get("radioSensorsModel");
            if(modelToAnalyse.get("collection"))
            {
              for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
              {
                singleModel = modelToAnalyse.get("collection").models[j];
                dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                  productCode        : singleModel.get("productCode"),
                  productLabel       : singleModel.get("productLabel"),
                  packageClassLabel  : singleModel.get("packageClassLabel"),
                  packageClassId     : singleModel.get("packageClassId"),
                  quantity           : 1,
                  price              : singleModel.get("price")
                });

                for (l=0; l<singleModel.get("secondaryProducts").length; l++)
                {
                  dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                    productCode        : singleModel.get("secondaryProducts")[l].get("productCode"),
                    productLabel       : singleModel.get("secondaryProducts")[l].get("productLabel"),
                    packageClassLabel  : singleModel.get("secondaryProducts")[l].get("packageClassLabel"),
                    packageClassId     : singleModel.get("secondaryProducts")[l].get("packageClassId"),
                    quantity           : 1,
                    price              : singleModel.get("secondaryProducts")[l].get("price")
                  });
                }
              }
            }
          }
          zonesItems.push(zoneToPush);
        }

        var product;
        var retrieveProductCode   = function(item) {return item.productCode;};
        var checkNonZeroQuantity  = function(item) {return item.quantity>0;};
        var sumQuantities         = function(memo, item){return memo + item.quantity;};

        for (i=0; i<zonesItems.length; i++)
        {
          if (zonesItems[i].items instanceof Array)
          {
            zonesItems[i].items   = _.filter(zonesItems[i].items, checkNonZeroQuantity);

            /*Grouping products*/
            zonesItems[i].items   = _.groupBy(zonesItems[i].items, retrieveProductCode);

            /*Sum quantities*/
            for (product in zonesItems[i].items)
              zonesItems[i].items[product][0].totalQuantity = _.reduce(zonesItems[i].items[product], sumQuantities, 0.00);
          }
        }
        BticinoS4B.solution.intrusionDetection.zonesItems = zonesItems;
        BticinoS4B.Instances.Models.ApplicationModel.set("zonesItems", BticinoS4B.solution.intrusionDetection.zonesItems);
      },

      loadProject                         : function(model) {
        this.collection = new this.ZoneCollection([], {stepEventAggregator:this.get("stepEventAggregator")});

        //Load inserters zone
        this.loadAdditionalZone(
          _.extend(
            {name        : "IDS_WAI1001_9006", number : 0},//-1},
            model.inserters
          )
        );

        //Load auxiliaries zone
        this.loadAdditionalZone(
          _.extend(
            {name        : "IDS_WAI1001_9007", number : 9},
            model.auxiliaries
          )
        );

        if(model.zones)
          for (var i=0; i<model.zones.length; i++)
          {
            this.loadZone(model.zones[i]);
          }

        this.get("stepEventAggregator").trigger("zone:loaded");
        this.get("stepEventAggregator").trigger("render:requested");
        this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
        window.BticinoS4B.eventAggregator.trigger("zone:selectionRequested", [1]);
      }
    }),
    Views         : Views
  });

  // Required, return the module for AMD compliance
  return intrusionDetectionZoneStep;

});